export default __webpack_public_path__ + "static/media/f.2c9a27fc.wav";